import anytimeConsultationShiftApi from "../../api/anytime_consultation_shifts";
import * as mutationTypes from "../mutation-types";

const state = {
  anytimeConsultationShiftUpdateErrorDetail: "",
  onShift: false,
  noticeExpiration: false,
};

const getters = {
  anytimeConsultationShiftUpdateErrorDetail : state => state.anytimeConsultationShiftUpdateErrorDetail,
  onShift: state => state.onShift,
  noticeExpiration: state => state.noticeExpiration,
};

// 一覧画面の表示・ルート変更のたびに受付状態を取り直すため、リクエストが並行し得る。
// 古いレスポンスが新しい値を上書きして誤った受付ステータスを表示しないよう、種類ごとの世代IDで判定する
const latestShiftStatusRequestIds = {
  onShift: 0,
  noticeExpiration: 0,
};

const startShiftStatusRequest = (key) => {
  latestShiftStatusRequestIds[key] += 1;
  return latestShiftStatusRequestIds[key];
};

const isLatestShiftStatusRequest = (key, requestId) => requestId === latestShiftStatusRequestIds[key];

const actions = {
  createAnytimeConsultationShift({ commit }, params) {
    return new Promise((resolve, reject) => {
      anytimeConsultationShiftApi.create(
        params,
        () => {
          let shiftUpdateErrorDetail = "";
          commit(mutationTypes.AC_SHIFT_UPDATE_ERROR_DETAIL, { shiftUpdateErrorDetail });
          resolve();
        },
        (error) => {
          let shiftUpdateErrorDetail = error.response.data["message"];
          commit(mutationTypes.AC_SHIFT_UPDATE_ERROR_DETAIL, { shiftUpdateErrorDetail });
          reject();
        });
    });
  },

  updateAnytimeConsultationShift({ commit }, params) {
    return new Promise((resolve, reject) => {
      anytimeConsultationShiftApi.update(
        params,
        () => {
          let shiftUpdateErrorDetail = "";
          commit(mutationTypes.AC_SHIFT_UPDATE_ERROR_DETAIL, { shiftUpdateErrorDetail });
          resolve();
        },
        (error) => {
          let shiftUpdateErrorDetail = error.response.data["message"];
          commit(mutationTypes.AC_SHIFT_UPDATE_ERROR_DETAIL, { shiftUpdateErrorDetail });
          reject();
        });
    });
  },

  deleteAnytimeConsultationShift({ commit }, params) {
    return new Promise((resolve, reject) => {
      anytimeConsultationShiftApi.delete(
        params,
        () => {
          let shiftUpdateErrorDetail = "";
          commit(mutationTypes.AC_SHIFT_UPDATE_ERROR_DETAIL, { shiftUpdateErrorDetail });
          resolve();
        },
        (error) => {
          let shiftUpdateErrorDetail = error.response.data["message"];
          commit(mutationTypes.AC_SHIFT_UPDATE_ERROR_DETAIL, { shiftUpdateErrorDetail });
          reject();
        });
    });
  },

  isOnAnytimeConsultationShift({ commit }, params) {
    const requestId = startShiftStatusRequest("onShift");
    return new Promise((resolve) => {
      anytimeConsultationShiftApi.isOnShift(onShift => {
        if (!isLatestShiftStatusRequest("onShift", requestId)) {
          resolve(false);
          return;
        }
        commit(mutationTypes.ASSIGN_IS_ON_ANYTIME_CONSULTATION_SHIFT, { onShift });
        resolve(true);
      }, params, () => {
        resolve(false);
      });
    });
  },

  isAnswerNoticeExpiration({ commit }, params) {
    const requestId = startShiftStatusRequest("noticeExpiration");
    return new Promise((resolve) => {
      anytimeConsultationShiftApi.isNoticeExpiration(noticeExpiration => {
        if (!isLatestShiftStatusRequest("noticeExpiration", requestId)) {
          resolve(false);
          return;
        }
        commit(mutationTypes.ASSIGN_IS_NOTICE_EXPIRATION, { noticeExpiration });
        resolve(true);
      }, params, () => {
        resolve(false);
      });
    });
  },
};

const mutations = {
  [mutationTypes.AC_SHIFT_UPDATE_ERROR_DETAIL](state, { shiftUpdateErrorDetail }) {
    state.anytimeConsultationShiftUpdateErrorDetail = shiftUpdateErrorDetail;
  },
  [mutationTypes.ASSIGN_IS_ON_ANYTIME_CONSULTATION_SHIFT](state, { onShift }) {
    state.onShift =  onShift;
  },
  [mutationTypes.ASSIGN_IS_NOTICE_EXPIRATION](state, { noticeExpiration }) {
    state.noticeExpiration =  noticeExpiration;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
